import * as React from 'react';

import Icon from './Icon';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const LeafBorderIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path d="M8.04 16.84c1.01-2.51 2.15-5.38 6.46-6.34 0 0-5 0-6.62 4.63 0 0-.88-.88-.88-1.88 0-1 1-3.12 3.5-3.62.71-.13 1.5-.26 2.28-.37C14.75 9 16.64 8.72 17 8c0 0-1.5 8.5-7 8.5-.18 0-.43-.06-.67-.15l-.47 1.15-.95-.33.13-.33ZM12 4.5c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8Zm0-2C6.5 2.5 2 7 2 12.5s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10Z" />
    </Icon>
  );
};

export default LeafBorderIcon;
